import React, { useState } from "react";
import {
  Box,
  Card,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from "@chakra-ui/react";
import Issue_create from "./Issue_create";
import Assigned_teachers_book from "./Teacher/Assigned_teachers_book";
import Assigned_student_book from "./Student/Assigned_student_book";

const Issue = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <Box variant="outline" overflow="hidden" px={2}>
      {/* Issue creation form */}
      <Box
        // shadow="md"
        border="0.2px solid"
        borderColor="gray.300"
        borderRadius="md"
      >
        {" "}
        <Issue_create />
      </Box>

      {/* Styled Tabs */}
      <Tabs
        index={selectedTab}
        onChange={(index) => setSelectedTab(index)}
        mt={8}
        variant="soft-rounded"
        colorScheme="teal"
        isFitted
        // p={2}
        borderRadius="md"
        bg={useColorModeValue("white", "gray.700")}
      >
        <Box display="flex" justifyContent="flex-end" mb={5}>
          <TabList
            border="1px solid"
            borderColor={useColorModeValue("gray.300", "gray.600")}
            borderRadius="full"
            overflow="hidden"
          >
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                // borderRadius: "md",
              }}
              py={2}
            >
              Students
            </Tab>
            <Tab
              _selected={{
                bg: useColorModeValue("teal.100", "teal.600"),
                color: "teal.800",
                fontWeight: "bold",
                // borderRadius: "md",
              }}
              py={2}
            >
              Teachers
            </Tab>
          </TabList>
        </Box>

        <TabPanels>
          <TabPanel p={1}>
            <Assigned_student_book />
          </TabPanel>
          <TabPanel p={1}>
            <Assigned_teachers_book />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Issue;
